import styled, { css } from 'styled-components';
import { colors } from 'stylesheets';

const sizes = {
  xxxsmall: css`
  min-width: 12px;
  min-height: 12px;
  max-width: 12px;
  max-height: 12px;
  font-size: 10px;
  `,
  xxsmall: css`
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    font-size: 10px;
  `,
  xsmall: css`
    min-width: 22px;
    min-height: 22px;
    max-width: 22px;
    max-height: 22px;
    font-size: 16px;
  `,
  small: css`
    min-width: 27px;
    min-height: 27px;
    max-width: 27px;
    max-height: 27px;
    font-size: 16px;
  `,
  medium: css`
    min-width: 40px;
    min-height: 40px;
    max-width: 40px;
    max-height: 40px;
    font-size: 24px;
  `,
};

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ isLink }) => isLink
    && css`
      cursor: pointer;
    `}

  ${({ withChildren }) => withChildren
    && css`
      background: ${colors.greySilver};
      color: ${colors.white};
    `}

  ${({ hasShadow }) => hasShadow
    && css`
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.26);
    `}

  ${({ rounded }) => rounded
    && css`
      border-radius: 50%;
    `}

  ${({ isIcon }) => isIcon
    && css`
      padding: 5%;
    `}

  ${({ size }) => sizes[size]}

  & > img {
    width: 100%;
    height: 100%;

    ${({ size }) => sizes[size]}

    ${({ rounded, isIcon }) => rounded
      && !isIcon
      && css`
        border-radius: 50%;
      `
    }

  ${({ row }) => row
  && css`
    transform: scale(1,2);
  `}
  }
`;

export const WrapperImages = styled.div`
  display: flex;
  align-items: center;

  & > :not(:first-child) {
    margin-left: -4px;
  }
`;
